$(document).ready(function() {
  var currentUrl = window.location.href; // get current URL

  // add click event listener to all buttons on the page
  $('button').click(function() {
    $.ajax({
      url: currentUrl, // reload the current page URL
      type: "GET",
      success: function(data) {
        $("#your-div-id-here").html(data); // update the content of a specific HTML element
        console.log("Reload successful");
      },
      error: function(xhr, status, error) {
        console.log("Reload failed");
      }
    });
  });
});